{
  "$id": "http://softball.app/schemas/team",
  "title": "Team",
  "type": "object",
  "required": ["id", "name", "games"],
  "properties": {
    "id": {
      "type": "string",
      "tsType": "TeamId",
      "description": "Random 64-bit unique identifier for this team"
    },
    "name": {
      "type": "string",
      "description": "Human identifier for this team. Opponent name is used by the app. May not be unique."
    },
    "games": {
      "type": "array",
      "description": "All games played by this team",
      "items": { 
        "type": "object",
        "unevaluatedProperties": false,
        "$ref": "http://softball.app/schemas/game" 
      }
    }
  }
}

